export default {
    mounted: (el, binding) => {
        el.style.backgroundImage = `url(${binding.value})`;
    }
};
